import LockIcon from '@mui/icons-material/Lock';
import { Alert, Typography } from '@mui/material';
import { InternalLink } from './InternalLink';

export function UpgradeAccountToAccessMessage({
  hideLockIcon = false,
  message = ' your account to access',
}: {
  hideLockIcon?: boolean;
  message?: string;
}) {
  return (
    <Alert
      severity="warning"
      variant="outlined"
      icon={hideLockIcon ? false : <LockIcon fontSize="inherit" />}
    >
      <Typography variant="body1" sx={{
        textAlign: "center"
      }}>
        <InternalLink to="/plans">Upgrade </InternalLink>
        {message}
      </Typography>
    </Alert>
  );
}
